import React, { useEffect } from 'react';
import Message from '../../components/message/Message';
import { Dealer } from '../../gql/graphql';
import { inIframe, modalResolver } from '../../helpers';
import { Role } from '../../types/role';
import { ExitCodes, ModalMessage, ModalMessageFailure } from '../../helpers/modal/modal.helper';
import { SegmentProps } from '../../state-machine/actions/segment';
import { useTranslation } from 'react-i18next';

type Props = SegmentProps & {
  orderId: string;
  role: Role;
  dealer: Dealer;
  heading?: string;
  body?: string | JSX.Element;
  buttonText?: string;
  additionalBody?: string;
  exitCode?: ExitCodes; //optional but defaulted to 7
  exitReason?: string; //optional but defaults to internal service error
};

const InternalError: React.FC<Props> = ({ orderId, role, dealer, exitCode = 7, exitReason = 'internal service error', track, page, ...rest }: Props) => {
  const { t } = useTranslation();
  useEffect(() => {
    page('Internal Error');
    // const payload: ModalMessage = {
    //   wcfSuccess: false,
    //   closeModal: false,
    //   payload: {
    //     reason: exitReason,
    //     reasonCode: exitCode, //default to 7 - generic modal close
    //     orderId: orderId,
    //   } as ModalMessageFailure,
    // };
    track('Closing modal at internal service error', { orderId });
    // modalResolver(payload, domains);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCloseModal = () => {
    const payload: ModalMessage = {
      wcfSuccess: false,
      closeModal: true,
      payload: {
        reason: 'modal closed',
        reasonCode: ExitCodes.generalCloseModal,
        orderId: orderId,
      } as ModalMessageFailure,
    };
    modalResolver(payload, dealer.domains);
  };
  return (
    <Message
      heading={rest.heading || t(($) => $.error.havingTrouble)}
      body={rest.body || t(($) => $.error.unableToCompleteRequest)}
      additionalBody={rest.additionalBody || ''}
      buttonText={rest.buttonText || t(($) => $.buttonLabels.exit)}
      buttonClick={handleCloseModal}
      shouldShowButton={inIframe() || role !== Role.Customer} // Do not show for full screen customer role
    />
  );
};

export default InternalError;
